// LEGACY: Uses SCSS with CSS modules. New code should use @metarouter-private/mr-mui components instead.
// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';
import pt from 'prop-types';
import cx from 'classnames';
import { MrAvatar } from '@ion/components';
import StarterKits from '../../starterkits/starterkits-state';
import s from './logos.module.scss';
import LOGO_MAP from './logos';

const IntegrationLogo = ({ className, id, type = 'logo', ...props }) => {
  const { kits, kitById } = StarterKits();

  // retrieve integration starterkit from starterkits array
  const starterkit = kitById(kits, id);

  const logo = LOGO_MAP[id];

  if (!logo) {
    return <MrAvatar className={cx(s[type], className)} name={id} {...props} />;
  }

  return <MrAvatar src={logo} className={cx(s[type], className)} name={starterkit?.friendlyName} {...props} />;
};

IntegrationLogo.propTypes = {
  className: pt.string,
  id: pt.string,
  type: pt.string,
};

export default IntegrationLogo;
